// Book value history: the Desk Dashboard card of `wealth.portfolio.book-history`
// (ADR-0027, SEP-297). The card reads its own data, so the page holds no
// state for it.
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const BookHistoryCard = lazy(() =>
    import('./book-history.slots').then((m) => ({ default: m.BookHistoryCard })),
);

export default defineWebFeature({
    id: 'wealth.portfolio.book-history',
    slots: {
        'desk.dashboard.cards': [
            {
                key: 'book-history',
                order: 55,
                span: 12,
                rows: 10,
                spans: [12],
                title: 'Book value',
                summary: 'The total value of the book over time, and what changed it.',
                emptyBehaviour: 'keep',
                Component: BookHistoryCard,
            },
        ],
    },
});
